module.exports = __webpack_public_path__ + "img/call-clearly.a989a681.png";